import type {TuiLanguageKit} from '@taiga-ui/i18n/types';

export const TUI_ARABIC_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'إلغاء',
    done: 'تم',
    more: 'المزيد',
    otherDate: 'تاريخ آخر...',
    showAll: 'إظهار الكل',
    hide: 'إخفاء',
    mobileCalendarTexts: [
        'اختيار يوم',
        'اختيار فترة',
        'اختيار أيام',
    ],
    range: ['من', 'إلى'],
    countTexts: ['المزيد', 'أقل'],
    time: {
        'HH:MM': 'HH:MM', 
        'HH:MM AA': 'HH:MM AA', 
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'يوم.شهر.سنة', 
        MDY: 'شهر.يوم.سنة', 
        YMD: 'سنة.شهر.يوم', 
    },
    digitalInformationUnits: ['بايت', 'كيلوبايت', 'ميغابايت'],
    passwordTexts: ['إظهار كلمة المرور', 'إخفاء كلمة المرور'],
    copyTexts: ['نسخ', 'تم النسخ'],
    shortCalendarMonths: [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر',
    ],
    pagination: ['الصفحة السابقة', 'الصفحة التالية'],
    fileTexts: {
        loadingError: 'خطأ في التحميل',
        preview: 'معاينة',
        remove: 'حذف',
    },
    inputFileTexts: {
        defaultLabelSingle: 'أو قم بإسقاطه هنا',
        defaultLabelMultiple: 'أو قم بإسقاطها هنا',
        defaultLinkSingle: 'حدد ملفًا',
        defaultLinkMultiple: 'حدد ملفات',
        maxSizeRejectionReason: 'الملف كبير جدًا',
        formatRejectionReason: 'تنسيق الملف غير صحيح',
        drop: 'قم بإسقاط الملف هنا',
        dropMultiple: 'قم بإسقاط الملفات هنا',
    },
    multiSelectTexts: {
        all: 'تحديد الكل',
        none: 'عدم تحديد أي شيء',
    },
    confirm: {
        yes: 'نعم',
        no: 'لا',
    },
    previewTexts: {
        rotate: 'تدوير',
    },
    zoomTexts: {
        zoomOut: 'تكبير',
        zoomIn: 'تصغير',
        reset: 'إعادة تعيين',
    },
    phoneSearch: 'اكتب البلد أو الرمز',
};
